import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=a5dfd2c2&"
import script from "./ContactPage.vue?vue&type=script&lang=js&"
export * from "./ContactPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports